import { WRENCH_MODE_SCHEDULES_CRUD_ACTION_CREATORS } from '../actions/wrench_mode_schedules_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';

export const wrenchModeSchedulesRestCrudThunksForSupplier = new RestCrudThunks(
	'schedules',
	'schedule',
	'schedule',
	'schedules',
	WRENCH_MODE_SCHEDULES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'wrench_mode/'
);
